import React from 'react';
import { Select, FormItem, AutoComplete, Cascader } from 'formik-antd';
import styled from 'styled-components';
import { Form } from '@ant-design/compatible';
import '@ant-design/compatible/assets/index.css';
import { Select as SelectAntd, Typography } from 'antd';

const Item = styled(FormItem)`
		margin-bottom: 1em;
		display: ${({ isUploadForm }) => isUploadForm && `flex`};
		flex-direction: ${({ isUploadForm }) => isUploadForm && `column`};
		.ant-form-item-label {
		  text-align: left !important;
			label {
				font-size: ${({ reverse }) => reverse && '11px'};
				color: ${({ reverse }) => reverse && '#bbb'};
				text-transform: ${({ reverse }) => reverse && 'uppercase'};
				line-height: ${({ reverse }) => reverse && '1.4'};
				font-weight: ${({ reverse }) => reverse && '600'};
			}
			label {
				font-size: ${({ label }) => label && '15px'};
				line-height: ${({ label }) => label && '1.5'};
			}
		}
		.help-text {
			font-size: 12px;
			color: #999;
		}

		.ant-form-item-label{
			text-align: none !important;
		}
`;

function SelectInput({
	reverse = 0,
	options,
	helpText,
	name,
	label,
	independent = false,
	autocomplete,
	isUploadForm,
	cascader,
	showToolTip,
	...props
}) {
	if (independent)
		return (
			<Form.Item name={name || ''} label={label || ''} style={{ marginBottom: props.marginBottom || '' }}>
				<SelectAntd {...props} name={name || ''} onChange={props.onChange} style={{ width: props.width || '100%' }}>
					{(options || []).map(item => (
						<SelectAntd.Option key={item.value}>{item.label}</SelectAntd.Option>
					))}
				</SelectAntd>
			</Form.Item>
		);

	return (
		<Item
			name={name}
			reverse={reverse}
			label={label}
			isUploadForm={isUploadForm}
			style={{ width: props.width || '100%', marginBottom: props.marginBottom || '' }}
			{...props}
		>
			{autocomplete ? (
				<AutoComplete
					{...props}
					allowClear
					// showArrow
					name={name}
					dataSource={options}
					filterOption={(inputValue, option) => {
						const child = option.props.children || '';
						return child.toUpperCase().indexOf(inputValue.toUpperCase()) !== -1;
					}}
				/>
			) : cascader ? (
				<Cascader {...props} name={name} options={options} />
			) : (
				<Select {...props} name={name}>
					{(options || []).map(item => (
						<Select.Option key={item.value} value={item.value}>
							<Typography.Text ellipsis>{item.label}</Typography.Text>
						</Select.Option>
					))}
				</Select>
			)}

			{helpText && <span className="help-text">{helpText}</span>}
		</Item>
	);
}

export default SelectInput;
